import { createFileRoute } from "@tanstack/react-router";
import AccountBillingPage from "@/pages/account/Billing";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/account/billing/")({
  head: () => routeHead("/account/billing/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><AccountBillingPage /></PrivateRoute>
  );
}
